import { connect } from 'react-redux'
import { setErrorMessage } from 'actions/account'
import { setCartProduct, setCartProductDefault } from 'actions/account/cart'

const mapStateToProps = ({ cart: { cartForm } }) => ({ cartForm })
const actions = { setCartProduct, setCartProductDefault, setErrorMessage }

const withRedux = connect(mapStateToProps, actions)

export default withRedux
